import { action } from 'typesafe-actions';
import {
  ChannelType,
  IAccountRecovery,
  IAccountRecoveryResendCode,
  IAccountRecoveryVerification,
  IApiErrorPayloadWithCode,
  ICreateAccountRecovery,
  ICreateAccountRecoveryIdentity,
  IIdentity,
  IVerifyAccountRecovery,
  IVerifyIdentity,
  IVerifyIdentityRequest,
} from 'types';
import * as ActionTypes from './types';

// Account Recovert
export const createAccountRecoveryRequest = (authId: string, body: ICreateAccountRecovery, onSuccess?: () => void) => action(ActionTypes.AccountRecovery.CREATE_ACCOUNT_RECOVERY_REQUEST, { id: authId, body, onSuccess });
export const createAccountRecoverySuccess = (response: IAccountRecovery) => action(ActionTypes.AccountRecovery.CREATE_ACCOUNT_RECOVERY_SUCCESS, { response });
export const createAccountRecoveryError = (error: IApiErrorPayloadWithCode) => action(ActionTypes.AccountRecovery.CREATE_ACCOUNT_RECOVERY_FAIL, error);

export const verifyEmailRequest = (id: string, body: IVerifyAccountRecovery, onSuccess?: () => void) => action(ActionTypes.AccountRecovery.EMAIL_VERIFY_REQUEST, { id, body, onSuccess });
export const verifyEmailSuccess = (response: IAccountRecoveryVerification) => action(ActionTypes.AccountRecovery.EMAIL_VERIFY_SUCCESS, { response });
export const verifyEmailError = (error: IApiErrorPayloadWithCode) => action(ActionTypes.AccountRecovery.EMAIL_VERIFY_FAIL, error);

export const addIdentityRequest = (id: string, body: ICreateAccountRecoveryIdentity, onSuccess?: () => void) => action(ActionTypes.AccountRecovery.ADD_IDENTITY_REQUEST, { id, body, onSuccess });
export const addIdentitySuccess = (response: IIdentity) => action(ActionTypes.AccountRecovery.ADD_IDENTITY_SUCCESS, { response });
export const addIdentityError = (error: IApiErrorPayloadWithCode) => action(ActionTypes.AccountRecovery.ADD_IDENTITY_FAIL, error);

export const verifyIdentityRequest = (id: string, identityId: string, body: IVerifyIdentityRequest, onSuccess?: () => void) => action(ActionTypes.AccountRecovery.VERIFY_IDENTITY_REQUEST, { id, identityId, body, onSuccess });
export const verifyIdentitySuccess = (response: IVerifyIdentity) => action(ActionTypes.AccountRecovery.VERIFY_IDENTITY_SUCCESS, { response });
export const verifyIdentityError = (error: IApiErrorPayloadWithCode) => action(ActionTypes.AccountRecovery.VERIFY_IDENTITY_FAIL, error);

export const resendEmailVerificationCodeRequest = (id: string) => action(ActionTypes.AccountRecovery.RESEND_EMAIL_VERIFICATION_CODE_REQUEST, { id });
export const resendEmailVerificationCodeSuccess = (response: IAccountRecoveryResendCode) => action(ActionTypes.AccountRecovery.RESEND_EMAIL_VERIFICATION_CODE_SUCCESS, { response });
export const resendEmailVerificationCodeError = (error: IApiErrorPayloadWithCode, failToast?: boolean) => action(ActionTypes.AccountRecovery.RESEND_EMAIL_VERIFICATION_CODE_FAIL, error, { failToast });

export const resendIdentityVerificationCodeRequest = (id: string, identityId: string, channel?: ChannelType.CALL, successMessage?: string) =>
  action(ActionTypes.AccountRecovery.RESEND_IDENTITY_VERIFICATION_CODE_REQUEST, { id, identityId, channel, successMessage });
export const resendIdentityVerificationCodeSuccess = (response: IIdentity) => action(ActionTypes.AccountRecovery.RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS, { response });
export const resendIdentityVerificationCodeError = (error: IApiErrorPayloadWithCode, failToast?: boolean) => action(ActionTypes.AccountRecovery.RESEND_IDENTITY_VERIFICATION_CODE_FAIL, error, { failToast });

// Account Recovery Clear
export const accountRecoveryClear = () => action(ActionTypes.AccountRecovery.ACCOUNT_RECOVERY_CLEAR);

// Account Recovery Init
export const accountRecoveryInit = (authId: string, hasDob: boolean, hasPin: boolean) => action(ActionTypes.AccountRecovery.ACCOUNT_RECOVERY_INIT, { authId, hasDob, hasPin });
